import React, { Component } from 'react'
import { withRouter } from 'next/router';
import SiteLayout from "../layouts/SiteLayout";
import { MdRemoveRedEye } from "@react-icons/all-files/md/MdRemoveRedEye";
import { MdArrowForward } from "@react-icons/all-files/md/MdArrowForward";
import Validator from "../services/Validation";
import AuthAction from "../actions/AuthAction";
import UserAction from '../actions/UserAction';
import Cookie from "../services/Cookie";
import AuthCheck from "../services/AuthCheck";
import { toast } from "react-toastify";
import intersectionBy from "lodash/intersectionBy";
import Link from 'next/link'
import SlackWebHook from "../services/Slack";
import PropTypes from "prop-types";
import SidebarCTA from '../components/SidebarCTA';
import SiteLoader from '../components/SiteLoader';
import ChooseSurvey from '../components/ChooseSurvey';

const roles = [{ roleMachineName: 'users' }];

class Login extends Component {

    static getInitialProps({ query }) {
        return { query };
    }

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            validate: false,
            onLoad: false,
            source: '',
            undecided: false,
            pageLoading: true
        }
    }

    componentDidMount() {
        if (AuthCheck.checkCookie()) {
            this.props.router.push('/dashboard');
        } else {
            if (process.env.NEXT_PUBLIC_LOGIN_ENABLE === undefined || process.env.NEXT_PUBLIC_LOGIN_ENABLE === "true") {
                const { source, email } = this.props.query;
                if (source) {
                    this.setState({
                        ...this.state,
                        source,
                        email,
                        pageLoading: false
                    });
                } else {
                    this.setState({
                        ...this.state,
                        email,
                        pageLoading: false
                    });
                }
            }
            else {
                location.replace(process.env.NEXT_PUBLIC_REDIRECTION_URL + location.search + (location.search.trim() === '' ? '?' : '&') + 'platform=' + btoa(location.host));
            }
        }
    }

    gotoForgetPage = () => {
        const { email } = this.state;
        if (email !== '' && email !== undefined && email !== null) {
            let encryptedEmail = btoa(email);
            this.props.router.push('/forget-pass?email=' + encryptedEmail);
        } else {
            this.props.router.push('/forget-pass');
        }
    }

    onChange = (e) => {
        e.persist();
        this.setState({
            ...this.state,
            [e.target.name]: e.target.value,
            validate: false,
            onLoad: false
        });
    };

    login = (e) => {
        e.preventDefault();
        const { email, password } = this.state;
        this.setState({
            ...this.state,
            validate: true,
            onLoad: true
        }, () => {
            if (Validator.email(email) && Validator.passwordStrength(password, "week")) {
                AuthAction.loginUser(email.toLowerCase(), password).then((res) => {
                    const response = res.data.loginUser;
                    if (response.status === 'success' && response.code === '200') {
                        const data = response.data;
                        Cookie.setCookie('_token', data.accessToken, 7);
                        let user = AuthCheck.checkAuth();
                        let roleDetails = intersectionBy(Object.values(JSON.parse(user.roleDetails)), roles, 'roleMachineName');
                        if (roleDetails.length === 1 && (process.env.NEXT_PUBLIC_ORGANIZATION_ID === undefined || process.env.NEXT_PUBLIC_ORGANIZATION_ID === "false" || parseInt(process.env.NEXT_PUBLIC_ORGANIZATION_ID) === parseInt(user.orgId))) {
                            toast.success(`Hey ${user.firstName}, welcome back!`);
                            this.setState({
                                ...this.state,
                                pageLoading: true
                            });
                            this.checkSurvey();
                        } else {
                            Cookie.deleteCookie('_token');
                            toast.error("You don't have access to this platform");
                        }
                        this.setState({
                            ...this.state,
                            onLoad: false
                        })
                    } else {
                        SlackWebHook.sendSlackMessage('Login', 'login', `${response.message}`);
                        this.setState({
                            ...this.state,
                            onLoad: false
                        })
                        toast.error(response.message);
                    }
                }).catch((err) => {
                    SlackWebHook.sendSlackMessage('Login', 'login', `${err.message}`);
                    this.setState({ ...this.state, onLoad: false });
                    toast.error('Something went wrong');
                });
            }
            else {
                this.setState({ ...this.state, onLoad: false });
                toast.error('Please fill the mandatory fields');
            }
        });
    }

    unmask = () => {
        const eyeIcon = document.querySelector('.unmask');
        const passwordfield = document.querySelector('.password');
        const type = passwordfield.getAttribute('type') === 'password' ? 'text' : 'password';
        passwordfield.setAttribute('type', type);
        // toggle the icon
        eyeIcon.classList.toggle('active');
    }

    changeRoute = () => {
        let input = {
            next: this.props.query.next,
            referralCode: this.props.query.referralCode,
            email: this.props.query.email,
            source: this.props.query.source
        }
        this.props.router.push("/signup" + Validator.queryParamBind(input));
    }

    goToNextPage = () => {
        if(this.props.query.next && this.props.query.next !== ""){
            this.props.router.push(`${atob(this.props.query.next)}`);
        }else {
            this.props.router.push(`/dashboard`);
        }
    }

    checkSurvey = () => {
        UserAction.userSurvey(AuthCheck.checkAuth().userId, null).then((res) => {
            const response = res.data.fetchCourseWiseUserSurveyDetails;
            if (response.status === 'success' && response.code === '200') {
                if(response.data.courseData.length > 0 && response.data.selectedCourseId > 0){
                    this.goToNextPage();
                }else{
                    this.setState({
                        ...this.state,
                        pageLoading: false,
                        undecided: true
                    });
                }
            }else {
                toast.error("Something went wrong!");
            }
        }).catch((err) => {
            toast.error(err.message);
        })
    }

    render() {
        const { email, password, validate, onLoad, source, undecided, pageLoading } = this.state;

        return (
            <SiteLayout>
                {
                    pageLoading &&
                    <SiteLoader />
                }
                {
                    undecided ?
                        <ChooseSurvey courseId={null} goToNextPage={this.goToNextPage} source={source}/>
                        :
                        <div id="login" className="page-grid">
                            <SidebarCTA source={source} />
                            <div className="position-relative flex-center py-5 py-lg-0">
                                <div className='w-100'>
                                    <div className="d-lg-none">
                                        <Link href='/'>
                                            <a>
                                                <div className="logo-wrapper mx-auto mb-4">
                                                    {
                                                        source ?
                                                            <>
                                                                {
                                                                    source == "scholarly" &&
                                                                    <img width="110px" src="/images/scholarly-logo.png" alt="scholarly-logo" />
                                                                }
                                                                {
                                                                    source == "corporategurukul" &&
                                                                    <img width="110px" src="/images/corporategurukul-logo.png" alt="corporategurukul-logo" />
                                                                }
                                                            </>
                                                            :
                                                            <picture>
                                                                <source type="image/webp" srcSet={process.env.NEXT_PUBLIC_BRAND_LOGO} />
                                                                <source type="image/png" srcSet={process.env.NEXT_PUBLIC_BRAND_LOGO} />
                                                                <img src={process.env.NEXT_PUBLIC_BRAND_LOGO} alt="brand-logo" />
                                                            </picture>
                                                    }
                                                </div>
                                            </a>
                                        </Link>
                                    </div>
                                    <h3 className="text-center bold mb-4">Log into your account</h3>
                                    <div>
                                        <form id="loginForm" className="mb-5" onSubmit={this.login}>
                                            <div className="form-group mb-3">
                                                <label htmlFor="login-email" className="col-form-label">Email</label>
                                                <input type="email" id="login-email"
                                                    name="email" autoComplete="email"
                                                    value={email}
                                                    onChange={this.onChange}
                                                    className={`form-control ${validate && !Validator.email(email) && 'error'}`}
                                                    placeholder="Enter your Email"
                                                />
                                            </div>
                                            <div className="mb-5">
                                                <div className="form-group mb-2">
                                                    <label htmlFor="login-password" className="col-form-label">Password</label>
                                                    <div className="position-relative">
                                                        <input type="password" id="login-password"
                                                            onChange={this.onChange} autoComplete="current-password"
                                                            className={`form-control password ${validate && !Validator.passwordStrength(password, "week") && 'error'}`}
                                                            name="password"
                                                            value={password}
                                                            placeholder="Enter Password"
                                                        />
                                                        <div className="unmask" onClick={this.unmask}>
                                                            <MdRemoveRedEye fontSize="22px" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="flex-row justify-content-end">
                                                    <a className='txt-14--caption bold color-black pointer' onClick={this.gotoForgetPage}>Forgot Password?</a>
                                                </div>
                                            </div>
                                            <div>
                                                <button type="submit" className="btn-solid-large --primary w-100" disabled={onLoad}>
                                            Sign In
                                                    <span className={`icon-btn--layer ${onLoad ? 'no-border' : 'primary-border'}`}>
                                                        {onLoad ? <div className={`lds-ring --white`}><div /><div /><div /><div /></div> : <MdArrowForward fontSize="24px" />}
                                                    </span>
                                                </button>
                                            </div>
                                        </form>
                                        <hr className="hr-25 mb-3" />
                                        <h4 className="text-center bold">New here? &nbsp;
                                            <a className="inline-link text-primary pointer" onClick={this.changeRoute}>
                                                {
                                                    process.env.NEXT_PUBLIC_ENABLE_TRIAL === "true"?
                                                    'Start your free trial'
                                                    :
                                                    'Enroll Now'
                                                }
                                            </a>
                                        </h4>
                                    </div>
                                    <div className='w-50 w-md-25 mx-auto mt-4'>
                                        {
                                            (source && (source == "scholarly" || source == "corporategurukul")) &&
                                            <img src="/images/Powered-By.png" className='mx-auto w-auto' alt="powered-by" />
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                }
            </SiteLayout>
        )
    }
}

const propTypes = {
    router: PropTypes.object,
    query: PropTypes.any
}

Login.propTypes = propTypes;

export default withRouter(Login);
